import ISerializable from '../../../../lib/ISerializable';
import ImageWebsiteLogo, { ColorScheme } from './ImageWebsiteLogo';

export default class FoundWebsiteLogo
  extends ImageWebsiteLogo
  implements ISerializable
{
  constructor(
    private url: {
      ObjectURL: string;
      PresignedUrl: string;
    },
    private colors: ColorScheme,
    private dimensions: {
      width: number;
      height: number;
    }
  ) {
    super();
  }

  public getImageSrc(): string {
    return this.url.PresignedUrl;
  }

  public getFileUrl(): string {
    return this.url.ObjectURL;
  }

  public getId(): string {
    return this.url.ObjectURL;
  }

  public getAltText(): string {
    return 'site logo';
  }

  public getColors() {
    return this.colors;
  }

  public getDimensions() {
    return this.dimensions;
  }

  public serialize() {
    return JSON.stringify({
      value: {
        url: this.url,
        colors: this.colors,
        dimensions: this.dimensions
      },
      objectType: 'FoundWebsiteLogo'
    });
  }

  public deserialize(data: any) {
    let _data = JSON.parse(data);
    return new FoundWebsiteLogo(_data.url, _data.colors, _data.dimensions);
  }
}
